<template>
  <div style="margin: 0 auto;height:100%;overflow:hidden;">
    <el-row :gutter="20">
      <el-col :span="3" style="width:160px;padding:0px;height: 48px;">
        <img :src="logo" style="margin: 0px;padding: 4px 0px;width: 130px;" />
      </el-col>
      <el-col :span="6" style="padding:0px;margin: 0px 0px 0px 45px;line-height: 48px;height:48px;max-height:48px;" data-step="1" data-intro="常用应用一键触达，节省查找时间~">
        <el-autocomplete
          ref="autocomplete"
          class="inline-input"
          v-model="state1"
          :fetch-suggestions="querySearch"
          placeholder="请搜索应用"
          value-key="name"
          popper-class="select-option"
          :trigger-on-focus="false"
          @select="handleSelect">
            <template slot-scope="{ item }" class="el-autocomplete-li">
                  <el-image  :src="item.icon" style="width:36px;height:36px;padding:16px;"></el-image>
                    <el-tooltip class="item" effect="dark" placement="top-start">
                      <div slot="content">{{item.menuname}}</div>
                      <span :title="item.name" v-html="filterValue(item.name,state1)" class="menuTitle" style="overflow:hidden;text-overflow: ellipsis;white-space: nowrap;font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;font-weight: 400;color: #292B44;"></span>
                    </el-tooltip>
            </template>
          </el-autocomplete>
          <div style="display: inline-block;">
            <el-button style="height:32px;max-height:32px;" icon="el-icon-search" @click="querySearch1" ></el-button>
          </div>
      </el-col>
      <el-col :span="2" style="width:140px;padding-left: 24px;padding-right: 24px;">
        <div @click="guide()" class="iconfont icon-wenhao-xianxingyuankuang" style="font-size: 14px;font-family: PingFang SC-Regular, PingFang SC;font-weight: 400;color: #1890FF;height: 48px;line-height: 48px;">
          新手指引</div>
      </el-col>
      <el-col :span="10" style="float:right;padding:0px;">
        <el-dropdown
          style="float:right;margin-right:10px;height:48px;"
          @command="handleCommand"
          trigger="click"
        >
          <span style="padding-right: 20px;">
            <img :src="userPhoto" style="margin: 0px;padding: 8px 0px 8px 0px;" />
            <i
              style="position: absolute;top: 20px;right: 0px;"
              class="el-icon-arrow-down el-icon--right"
            ></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="info">{{$t('navigator.userInfo')}}</el-dropdown-item>
            <!-- <el-dropdown-item command="assetDetails">个人资产明细</el-dropdown-item> -->
            <!-- <el-dropdown-item command="langSelect">
              <lang-select class="right-menu-item hover-effect" />
            </el-dropdown-item> -->
            <!-- <el-dropdown-item command="switchingPost">
              <el-dropdown @command="switchPost" placement="left-start">
                <span class="theme-color">切换当前岗位</span>
                <el-dropdown-menu slot="dropdown" style="margin-right: 24px;">
                  <el-tooltip placement="top" :content="post.pathname" :key="post.postId" v-for="post in postMap">
                    <div>
                      <el-dropdown-item :command="post" :disabled="post.disabled">
                      <div>{{post.postname}}({{post.orgname}})</div>
                    </el-dropdown-item>
                    </div>
                  </el-tooltip>
                </el-dropdown-menu>
              </el-dropdown>
            </el-dropdown-item> -->
            <el-dropdown-item command="modifyPwd">修改密码</el-dropdown-item>
            <el-dropdown-item command="logout">退出系统</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <a style="height: 48px;line-height: 48px;float: right;margin-right: 8px;font-size: 14px !important;
        font-family: PingFang SC-Regular, PingFang SC !important;
        font-weight: 400 !important;
        color: #52535E !important;">{{SysTime}}！{{ currentUser.username }}</a>
        <span style="float:right !important;
        margin-right :30px !important;
        font-size: 14px !important;
        font-family: PingFang SC-Regular, PingFang SC !important;
        font-weight: 400 !important;
        color: #52535E !important;    height: 48px;line-height: 48px;">
        <haiyaMarquee></haiyaMarquee>
          <!-- 您好！{{ currentUser.username }}
          <span  style="
        font-size: 14px !important;
        font-family: PingFang SC-Regular, PingFang SC !important;
        font-weight: 400 !important;
        color: #52535E !important;" v-if="curOrg.name">所在部门：{{curOrg.name}}</span> -->
        </span>
      </el-col>
      <el-dialog 
        title="个人资产明细"
        :visible.sync="assetDetailsDialogVisible"
        :close-on-click-modal="false"
        top="12vh"
        width="860px">
        <div v-if="items.length>0">
          <div v-for="items in items" :key="items.index">
            <div v-for="item in items.obj" :key="item.index">
              <h4 class="warehouse">{{item.dwmc}}</h4>
              <template v-for="objs in item.items"> 
                <el-tooltip placement="top" :key="objs.zcmc" >
                  <div slot="content">唯一资产编码：{{objs.zcid}}<br/>规格型号：{{objs.ggxh}}</div>
                  <el-tag type="danger" style="margin:0px 0px 8px 8px" >{{objs.zcmc}}</el-tag> 
                </el-tooltip>
              </template>
            </div>
          </div>
        </div>
        <div v-else><p style="text-align: center;">暂无资产</p></div>
      </el-dialog>
      <el-dialog
        title="查看个人信息"
        :visible.sync="infoDialogVisible"
        :close-on-click-modal="false"
        top="12vh"
        width="860px"
      >
        <el-form v-if="curUser.user" :inline="true" ref="form" label-width="80px" size="mini">
          <el-form-item label="用户名称">
            <span class="content_span">{{curUser.user.fullname}}</span>
          </el-form-item>
          <el-form-item label="用户账号">
            <span class="content_span">{{curUser.user.account}}</span>
          </el-form-item>
          <el-form-item label="手机号码">
            <span class="content_span">{{curUser.user.mobile}}</span>
          </el-form-item>
          <el-form-item label="邮箱地址">
            <span class="content_span">{{curUser.user.email}}</span>
          </el-form-item>
          <el-form-item label="用户性别">
            <span class="content_span">{{curUser.user.sex}}</span>
          </el-form-item>
          <el-form-item label="用户状态">
            <span
              class="content_span"
            >{{curUser.user.status == '1'?'正常':curUser.user.status == '0'?'禁用':curUser.user.status == '-1'?'未激活':'离职'}}</span>
          </el-form-item>

          <el-form-item label="家庭地址" style="width: 100%;">
            <span class="content_span" style="width: 650px;">{{curUser.user.address}}</span>
          </el-form-item>
          <el-form-item style="width: 100%;" label="所属角色">
            <template v-for="name in curUser.role">
              <el-tag type="warning" size="small" :key="name" v-if="name">{{name}}</el-tag>
            </template>
          </el-form-item>
          <el-form-item style="width: 100%;" label="所属岗位">
            <el-tooltip
              :content="post.pathname"
              placement="top"
              :key="post.postId"
              v-for="post in curUser.post"
            >
              <el-tag type="success" size="small">{{post.postname}}</el-tag>
            </el-tooltip>
          </el-form-item>
          <el-form-item style="width: 100%;" label="所属组织">
            <el-tooltip
              :content="org.pathname"
              placement="top"
              :key="org.orgId"
              v-for="org in curUser.org"
            >
              <el-tag size="small">{{org.orgname}}</el-tag>
            </el-tooltip>
          </el-form-item>
        </el-form>
      </el-dialog>

      <el-dialog
        title="修改密码"
        :visible.sync="modifyPwdDialogVisible"
        :close-on-click-modal="false"
        top="20vh"
        width="500px"
        id="modlfy-dialog"
        @open="open"
      >
        <el-form :model="pwdForm" :rules="pwdRules" ref="pwdForm" label-width="120px" size="mini">
          <el-form-item label="旧密码" prop="old">
            <el-input type="password" v-model="pwdForm.old" placeholder="请输入旧密码"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="new">
            <el-input type="password" placeholder="请输入新密码" v-model="pwdForm.new"></el-input>
          </el-form-item>
          <el-form-item label="重复新密码" prop="newRepeat">
            <el-input type="password" placeholder="请再次输入新密码" v-model="pwdForm.newRepeat"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer" style="text-align: center;">
          <el-button size="small" type="primary" @click="submitForm">确认</el-button>
          <el-button size="small" @click="modifyPwdDialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </el-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import myMenu from "@/components/menu.vue";
import langSelect from "@/components/langSelect";
import haiyaMarquee from "../components/common/haiyaMarquee.vue";
import introJs from 'intro.js' // introjs库
import 'intro.js/introjs.css' // introjs默认css样式
import 'intro.js/themes/introjs-modern.css' // introjs主题
export default {
  name: "navigator",
  data() {
    var validateNew = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      }
      let config = this.pwdStrategy;
      if (config.enable == 1) {
        let pwdRule = config.pwdRule;
        let pwdLength = config.pwdLength;
        if (pwdRule) {
          if (value.length < pwdLength) {
            callback(new Error("新密码长度至少为" + pwdLength));
          } else if (pwdRule == 2) {
            var re = new RegExp("(?=.*[0-9])(?=.*[a-zA-Z])");
            if (!re.test(value)) {
              callback(new Error("新密码必须包含数字、字母"));
            } else {
              callback();
            }
          } else if (pwdRule == 3) {
            var re = new RegExp("(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9])");
            if (!re.test(value)) {
              callback(new Error("新密码必须包含数字、字母、特殊字符"));
            } else {
              callback();
            }
          } else if (pwdRule == 4) {
            var re = new RegExp(
              "(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9])"
            );
            if (!re.test(value)) {
              callback(new Error("新密码必须包含数字、大小字母、特殊字符"));
            } else {
              callback();
            }
          }
        }
      } else {
        if (value.length < 6) {
          callback(new Error("新密码长度至少为6"));
        } else {
          callback();
        }
      }
    };
    var validateold = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入旧密码"));
      } else {
        callback();
      }
    };
    var validateNewReapeat = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入新密码"));
      } else if (value !== this.pwdForm.new) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      logo: "",
      showLogo:true,
      infoDialogVisible: false,
      assetDetailsDialogVisible: false,
      modifyPwdDialogVisible: false,
      userPhoto: require("@/assets/img/touxiang.png"),
      pwdForm: {
        old: "",
        new: "",
        newRepeat: ""
      },
      pwdRules: {
        old: [{ validator: validateold, trigger: "blur" }],
        new: [{ validator: validateNew, trigger: "blur" }],
        newRepeat: [{ validator: validateNewReapeat, trigger: "blur" }]
      },
      count: 0,
      homePage: window.context.front +"/home",
      restaurants: [],
      state1: '',
      param:[],
      SysTime:'',
      items:[]
    };
    
  },
  computed: mapState({
    postMap: state => state.user.postMap || {},
    currentUser: state => {
      return state.login.currentUser ? state.login.currentUser : {};
    },
    curUser: state => state.user.currentUserDetail || {},
    curOrg: state => state.user.currentOrgDetail || {},
    pwdStrategy: state => state.user.pwdStrategy || {}
  }),
  mounted() {
    const _this = this;
    this.$http.get(`${window.context.portal}/flow/approvalItem/v1/getApprovalTime`).then((resp) => {
      let date = new Date(resp.data.message);
			if (date.getHours()<=6) {
				_this.SysTime = "凌晨好";
			} else if (date.getHours()<=8) {
				_this.SysTime = "早上好";
			}else if (date.getHours()<=11) {
				_this.SysTime = "上午好";
			}else if (date.getHours()<=13) {
				_this.SysTime = "中午好";
			}else if (date.getHours()<=18) {
				_this.SysTime = "下午好";
			}else{
				_this.SysTime = "晚上好";
			}
    });
    
    const currentUser = this.$store.state.login.currentUser;
    if(currentUser){
      //搜索菜单方法
        this.$http.post(`${window.context.portal}/bpm/haiyaapi/getmenu?account=`+currentUser.account).then((resp) => {
          _this.restaurants = resp.data;
        });

      let userAttrs = this.$store.state.login.currentUser.userAttrs;
      if(userAttrs){
        let tenantId = userAttrs.tenantId;
        //租户
        if(tenantId && tenantId !="-1"){
          let url = window.context.uc+"/uc/tenantManage/v1/getJson?id=" + tenantId;
          this.$http.get(url).then(resp => {
            if(resp.data){
              let tenantManage = resp.data;
              if(tenantManage.frontLogo){
                let frontLogo = JSON.parse(tenantManage.frontLogo);
                if(frontLogo && frontLogo.length >0 ){
                  _this.showLogo = true;
                  _this.logo = window.context.portal + "/system/file/v1/downloadFile?fileId=" + frontLogo[0].id;
                }
              }
            }
          }, error => {
              reject(error);
          })
        }else{
          //不是租户
          _this.sysSetting();
        }
      }else{
        //不是租户
        _this.sysSetting();
      }
    }else{
      //不是租户
      _this.sysSetting();
    }
    setTimeout(() => {
      this.$route.path !== "/" &&
        this.$store.dispatch("user/loadCurrentUserDetail").then(data => {
          if (data) {
            var promise = this.$store.dispatch("user/getCurrent");
            promise.then(data => {
              if (data.photo && data.photo.indexOf("img/defaultPhoto") < 0) {
                this.$store
                  .dispatch("menu/downloadImg", data.photo)
                  .then(res => {
                    if (res != "") {
                      this.userPhoto = res;
                    }
                  });
              }
            });
          }
        });
    }, 1200);

  },
  watch: {
    //第一次加载著部门，当前切换岗位部门时当前部门发生改变
    "$store.state.user.postCharge": function() {
      const postCharge = this.$store.state.user.postCharge;
      this.count += 1;
      if (postCharge.org && this.count > 1) {
        this.$store.dispatch("user/setcurrentOrg", postCharge.org);
      }
    }
    
  },
  methods: {
    guide() {
      let User = JSON.parse(window.sessionStorage.currentUser);
      introJs().setOptions({
        prevLabel: "上一步",
        nextLabel: "下一步",
        skipLabel: "x",
        doneLabel: "结束",
        disableInteraction:true,//是否禁止交互
        hidePrev:true,// 隐藏第一步中的上一个按钮
        exitOnOverlayClick: false,//是否允许点击空白处退出
        exitOnEsc: false,//是否使用键盘Esc退出
        showStepNumbers:false,//是否显示说明的数据步骤
        showBullets: true,//是否使用点点点显示进度
        scrollToElement:true,//是否滑动到高亮的区域
        showProgress:false,//是否显示进度条
        tooltipClass: '',//引导说明文本框的样式 
        highlightClass:'',//说明高亮区域的样式
      }).oncomplete(function () {
          //点击结束按钮后， 执行的事件
      }).onexit(function () {
          //点击结束按钮后， 执行的事件
      }).start();
  },
    //获取系统默认配置 系统Logo、名称
    sysSetting(){
      const _this = this;
      let url = window.context.portal+"/sys/sysProperties/v1/getDecryptBySysSetting";
      _this.$http.get(url).then(response => {
          if(response && response.data && response.data.value){
            let  sysSettingData = JSON.parse(response.data.value);
            if(sysSettingData.frontLogo.length>0){
              let frontLogo = sysSettingData.frontLogo;
              _this.showLogo = true;
              _this.logo = window.context.portal + "/system/file/v1/downloadFile?fileId=" + frontLogo[0].id;
            }else{
              this.logo = require("@/assets/img/20241021141605.png");
            }
          }else{
            this.logo = require("@/assets/img/20241021141605.png");
          }
      });
    },
    open() {
      this.$store.dispatch("user/getDefPwdStrategy");
    },
    handleCommand(command) {
      switch (command) {
        case "logout":
		  //退出登陆时把vuex 里面的一些值清空
          this.$store.dispatch("menu/setCopyMenus",[]);//菜单
          let loginRouthPath =
            localStorage.getItem(
              this.$store.state.login.currentUser.account + "loginRoutePath"
            ) || "/login";
          this.$store.dispatch("login/logoutAndCleanUp").then(() => {
            switch (window.ssoConfig.mode) {
              case "cas":
                window.sessionStorage.removeItem("currentUser");
                window.location.href =
                  window.ssoConfig.logout +
                  "?service=" +
                  window.location.href.split("?")[0];
                break;
              case "oauth":
                break;

              default:
                this.$router.push({
                  path: loginRouthPath
                });
                break;
            }
          });
          break;
        case "info":
          this.infoDialogVisible = true;
          break;
        case "assetDetails":
          this.assetDetailsDialogVisible = true;
          this.wareAsset();
          break;
        case "modifyPwd":
          this.modifyPwdDialogVisible = true;
          if (this.$refs["pwdForm"]) {
            this.$refs["pwdForm"].resetFields();
          }
          break;
      }
    },
    submitForm() {
      this.$refs["pwdForm"].validate(valid => {
        if (valid) {
          this.$store
            .dispatch("user/modifyPwd", {
              oldPwd: this.pwdForm.old,
              newPwd: this.pwdForm.new
            })
            .then(data => {
              if (data.state) {
                this.$message.success("修改密码成功");
                this.modifyPwdDialogVisible = false;
              } else {
                this.$message.error(data.message || "保存失败");
              }
            });
        }
      });
    },
    wareAsset(){
      let this_ = this;
      this_.items = [];
      this_.$http.post(window.context.portal+"/bpm/haiyaapi/getZcmc").then(response => {
          if(response.data){
            for(let i=0;i<response.data.length;i++){
              this_.$http.post(window.context.portal+"/bpm/haiyaapi/getGrzcmx?zcmc="+response.data[i].dwmc).then(response1 => {
                this_.items.push({
                  "obj":[
                    {
                      "dwmc":response.data[i].dwmc,
                      "items":response1.data
                    }]
                });
              });
            }
          }
      });
    },
    switchPost(item) {
      for (let obj in this.postMap) {
        this.postMap[obj].disabled = false;
      }
      item.disabled = true;
      //设置表单中当前岗位
      this.$store.dispatch("user/setpostMap", {
        postMap: this.postMap,
        postCharge: item
      });
      this.$store.dispatch("user/putInCacheOrgPost", {
        postMap: this.postMap,
        postCharge: item
      }).then(res => {
        this.$store.dispatch("user/setMasterByorgId",{
          orgid:item.orgid,
          userid:this.currentUser.userId
        }).then(resp => {
          this.$message.success(resp.message);
        });
      });
      
      this.infoDialogVisible = true;
      this.infoDialogVisible = false;
    } ,
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = [];
      for(let i=0;i<restaurants.length;i++){
        if(restaurants[i].name.indexOf(queryString.replace(/\s+/g,"")) > -1){//包含则返回
          results.push(restaurants[i]);
        }
      }
      cb(results);
    },
    querySearch1(){
      if(!this.state1){
        this.$message({
          message: '根据所输内容来查询',
          type: 'warning'
        })
        return;
      }
      this.$refs.autocomplete.activated = true;
      this.$refs.autocomplete.getData(this.state1)
    },
    handleSelect(item) {//将用户选中的菜单回填
      //this.param = [];//初始化 防止保留上次的查询记录
      //this.param.push(item);
      this.QueryMenu(item);
    },
    QueryMenu(item){//将用户选中的菜单回填数据发起链接请求
      // let arr = this.param;
      if(item){
        //类型为数据报表
        if(item.type==2){
          let urlParam = JSON.parse(item.url);
          window.open(window.context.front+"/statement/template/preview/"+urlParam.key+"/true","_blank","height=" +(screen.availHeight - 50) +",width=" +(screen.availWidth - 10));
        }

        //类型为视图报表
        if(item.type==3){
          let urlParam = JSON.parse(item.url);
          window.open(window.context.front+"/statement/querySql/queryView/"+urlParam.sqlAlias+"/"+urlParam.alias+"/true","_blank","height=" +(screen.availHeight - 50) +",width=" +(screen.availWidth - 10));
        }

        //类型为网页跳转
        if(item.type==5){
          window.open(window.context.front+"/"+item.url,"_blank","height=" +(screen.availHeight - 50) +",width=" +(screen.availWidth - 10));
          
        }

        //类型为表单 执行存储之类
        if(item.type==6){
          let urlParam = JSON.parse(item.url);
          window.open(window.context.front+"/previewForm/"+urlParam.id,"_blank","height=" +(screen.availHeight - 50) +",width=" +(screen.availWidth - 10));
        }

        //类型为流程
        if(item.type==8){
          window.open(window.context.front+"/agentStart/"+item.url+"/0");
        }
      }
    },

    filterValue (val,keyword) {
      const Reg = new RegExp(keyword, 'i');
      if (val) {
        return val.replace(Reg, `<span style="color: #409EFF;">${keyword}</span>`);
      }
    }

  },
  components: {
    // myMenu,
    langSelect,
    haiyaMarquee
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
@import "@/assets/css/iconfont.scss";
.theme-color{
  color: $--color-text-regular;
}
.el-row {
  text-color: #ededed;
  active-text-color: #fff;
  margin: 0 -20px;
}


div.el-dropdown, div.el-dropdown + span {
  color: #52535E !important;
  line-height: 48px;
  font-size: 14px !important;
}

.logo-link {
  color: #fff;
  text-decoration: none;
  font-size: 24px;
  font-weight: 400;
  line-height: 36px;
}

.el-form /deep/ .el-form-item__content > .el-tag {
  margin-right: 10px;
}

.content_span {
  color: #212121;
  border-bottom: 1px solid #ededed;
  width: 260px;
  display: inline-block;
  margin: 0 30px 0 10px;
}

#modlfy-dialog /deep/ .el-input__inner {
  width: 200px;
}

/deep/ .el-input__inner{
  border-radius: 0px !important;
}

/deep/ .el-dialog__body {
  padding: 4px 20px 30px;
}

.warehouse{
  font-size: 14px;
  font-family: "PingFang SC-Regular", "PingFang SC";
  font-weight: 400;
  color: rgb(82, 83, 94);
}

/deep/ .el-dialog__header .el-dialog__title {
  font-size: 16px;
}
</style>


